(function () {
  if (window.__alvaBvRuntime) return;
  window.__alvaBvRuntime = true;
  var surface = document.querySelector('#alva-bv-reviews, [data-alva-bv-pending="reviews"], [data-bv-show="reviews"]');
  if (!surface) return;
  var source = 'https://apps.bazaarvoice.com/deployments/alva/main_site/production/en_US/bv.js';
  var pending = false;
  var loaded = false;
  var preparing = false;
  var failedScript = null;
  var observer;

  function ensureRuntime() {
    if (pending || loaded || window.BV || window.$BV) return;
    var existing = Array.from(document.scripts).find(function (script) {
      return script !== failedScript && script.src.indexOf('apps.bazaarvoice.com/') !== -1 && /\/bv\.js(?:[?#]|$)/.test(script.src);
    });
    if (existing) {
      if (!existing.__alvaBvWatched) {
        existing.__alvaBvWatched = true;
        existing.addEventListener('error', function () { failedScript = existing; }, { once: true });
      }
      return;
    }
    pending = true;
    function success() { pending = false; loaded = true; }
    function failure() { pending = false; }
    var loader = window.AlvaFeatureLoader;
    if (loader && typeof loader.loadScript === 'function') {
      loader.loadScript({
        id: 'third-party:bazaarvoice', src: source,
        preconnect: 'https://apps.bazaarvoice.com', async: true, retries: 1,
        attributes: { 'data-alva-bv-runtime': '1' }
      }).then(success, failure);
    } else {
      var script = document.createElement('script');
      script.src = source;
      script.async = true;
      script.addEventListener('load', success, { once: true });
      script.addEventListener('error', function () { failedScript = script; failure(); script.remove(); }, { once: true });
      document.head.appendChild(script);
    }
  }

  function activate() {
    ensureRuntime();
    if (surface.getAttribute('data-bv-show') === 'reviews' || preparing) return;
    preparing = true;
    var loader = window.AlvaFeatureLoader;
    var config = window.AlvaReviewDesignConfig || {};
    function show() {
      surface.setAttribute('data-bv-show', 'reviews');
      surface.removeAttribute('data-alva-bv-pending');
      preparing = false;
      if (observer) observer.disconnect();
    }
    if (config.designScript && loader && typeof loader.loadScript === 'function') {
      loader.loadScript({ id: 'asset:alva-bv-design.js', src: config.designScript, async: true, retries: 1 }).catch(function () {});
    }
    if (config.stylesheet && loader && typeof loader.loadStyle === 'function') {
      loader.loadStyle({ id: 'style:bazaarvoice-reviews', src: config.stylesheet, retries: 1 }).then(show, show);
    } else show();
  }

  function onIntent(event) {
    var target = event.target;
    if (target && target.closest && target.closest('[data-alva-bv-trigger], a[href="#alva-bv-reviews"], a[href="#BVRRContainer"], #alva-bv-reviews')) activate();
  }

  function onHash() {
    if (/^#(?:alva-bv-reviews|BVRRContainer)$/.test(window.location.hash) || /[?&](?:bvrrp|bvstate)=/.test(window.location.search)) {
      activate();
      if (window.location.hash === '#BVRRContainer' && !document.getElementById('BVRRContainer')) surface.scrollIntoView({ block: 'start' });
    }
  }

  ['pointerover', 'pointerdown', 'focusin', 'click'].forEach(function (name) {
    document.addEventListener(name, onIntent, { capture: true, passive: true });
  });
  document.addEventListener('alva:reviews:request', activate);
  window.addEventListener('hashchange', onHash);
  if ('IntersectionObserver' in window) {
    observer = new window.IntersectionObserver(function (entries) {
      if (entries.some(function (entry) { return entry.isIntersecting; })) activate();
    }, { rootMargin: '1000px 0px' });
    observer.observe(surface);
  } else activate();
  onHash();
})();
